import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAxL97G2aD-_5hu54XscX5zZeZcLlyXt9c",
  authDomain: "tradefix-935b5.firebaseapp.com",
  projectId: "tradefix-935b5",
  storageBucket: "tradefix-935b5.firebasestorage.app",
  messagingSenderId: "639062559445",
  appId: "1:639062559445:web:3067b4dad484ab061db05c",
  measurementId: "G-QPKELCEW2J"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export default app;
